/**
 * This function checks if a point is inside the bounding box of a node
 * @param node
 * @param point
 * @returns boolean true if point is inside the bounding box of the node
 */
export const checkAABB = (
  layoutValues: {
    x: number;
    y: number;
    width: number;
    height: number;
  },
  point: { x: number; y: number }
) => {
  const { x, y, width, height } = layoutValues;
  return (
    point.x >= x &&
    point.x <= x + width &&
    point.y >= y &&
    point.y <= y + height
  );
};

/**
 * This function returns the absolute distance between two points
 * @param point1
 * @param point2
 * @returns absolute distance between two points
 */
export const getDistance = (
  point1: { x: number; y: number },
  point2: { x: number; y: number }
) => {
  return Math.sqrt(
    Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2)
  );
};
